'use strict';

import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersOperations, usersSelectors } from '@/state/domains/users';

import Home from './components/Home';
import UsersMenu from './components/UsersMenu';
import Actions from './components/Actions';
import DateUI from './components/DateUI';
import UserMenu from './components/UserMenu';
import Link from '@/views/common/Link';

import s from './styles.scss';

const sx = cn.bind(s);

export default connect(
	(state, props) => ({
		date: appSelectors.getPageDate(state, props),
		username: appSelectors.getPageUsername(state, props),
		pageUser: usersSelectors.getPageUser(state, props),
		loggedInUser: usersSelectors.getLoggedInUser(state, props),
		location: appSelectors.getLocation(state, props),
		page: appSelectors.getPage(state, props),
		pageId: appSelectors.getPageId(state, props),
		pageUrl: appSelectors.getPageUrl(state, props),
		urlParams: appSelectors.getUrlParams(state, props),
		user: usersSelectors.getPageUser(state, props),
		actionMode: appSelectors.getActionMode(state, props),
	}),
	{
	}
)(
	({
		date,
		pageUser,
		loggedInUser,
		location,
		page,
		pageId,
		pageUrl,
		pageContext,
		actionMode,
		toggleStats,
		toggleImport,
		urlParams,
		setMenuOpen,
		setMenuClose,
	}) => {

		if (!loggedInUser) {
			return <div />;
		}

		const includeDateUI = [
			'user-weekly',
			'daily-route',
		].includes(pageId);

		const includeRouteLink = [
			'daily-route',
			'daily-location',
			'daily-nojob',
		].includes(pageId);

		const includeUsersLink = loggedInUser.capabilities.includes('searchUsers');
		const includeJobs = loggedInUser.capabilities.includes('viewJobs');
		const includePlaces = loggedInUser.capabilities.includes('viewPlaces');

		const includeActions = [ 'importJobs', 'createUser', 'createPlace' ].some(
			c => loggedInUser.capabilities.includes(c)
		);

		const username = loggedInUser?.username;

		const routeLinkObj = [ 'users' ].includes(pageId) ? 
		{
			pathname: `/user/${ username }/${ date }/route`,
		} :
		{
			pathname: `/user/${ username }/${ date }/route`,
		};

		return (
			<>
				<div className={ s.leftCont }>
					<ul className={ s.left }>
						<li className={ s.btnText }>
							<Home />
						</li>
						{
							includeUsersLink &&
							<li className={ s.dropdownBtn }>
								<UsersMenu />
							</li>
						}
						{
							includeJobs &&
							<li className={ s.btnText }>
								<Link
									to={{ pathname: '/jobs' }}
									className={ s.link }
								>
									Jobs
								</Link>
							</li>
						}
						{
							false && includePlaces &&
							<li className={ s.btnText }>
								<Link
									to={{ pathname: '/places' }}
									className={ s.link }
								>
									Places
								</Link>
							</li>
						}
						{
							includeRouteLink &&
							<li className={ s.btnText }>
								<Link
									to={ routeLinkObj }
									className={ s.link }
									isDisabled={ pageId === 'daily-route' }
								>
									Route
								</Link>
							</li>
						}
						{
							includeActions &&
							<li className={ s.dropdownBtn }>
								<Actions />
							</li>
						}
					</ul>
				</div>
				<div className={ s.middle }>
					{
						includeDateUI &&
						<div className={ s.btn }>
							<DateUI />
						</div>
					}
				</div>
				<div className={ s.rightCont }>
					<ul className={ s.right }>
						
						<li className={ s.btn }>
							<UserMenu />
						</li>
					</ul>
				</div>
			</>
		);
	}
);
